<template>
  <div id="app">
    <div class="tbl-schedules">
      <!-- desktop -->
      <div v-if="mediaquery > 3">
        <el-row>
          <el-col :md="15" :lg="14" :xl="12">
            <el-row class="tbl-head">
              <el-col :md="1" :lg="1" :xl="1">&nbsp;</el-col>
              <el-col :md="5" :lg="5" :xl="5">{{ $t('deck.code') }}</el-col>
              <el-col :md="8" :lg="8" :xl="8">{{ $t('deck.date') }}</el-col>
              <el-col :md="4" :lg="3" :xl="3">{{ $t('deck.duration') }}</el-col>
              <el-col :md="5" :lg="6" :xl="6" style="text-align: end;">{{ $t('deck.price-pp') }}</el-col>
              <el-col :md="1" :lg="1" :xl="1">&nbsp;</el-col>
            </el-row>
          </el-col>
          <el-col :md="9" :lg="10" :xl="12">
            <el-row class="tbl-head">&nbsp;</el-row>
          </el-col>
        </el-row>
        <el-row v-for="(schedule, index) in schedules" :key="'schedule_' + index" class="tbl-row">
          <el-col :md="15" :lg="14" :xl="12">
            <el-row>
              <el-col :md="1" :lg="1" :xl="1">&nbsp;</el-col>
              <el-col :md="5" :lg="5" :xl="5">{{ schedule.code }}</el-col>
              <el-col :md="8" :lg="8" :xl="8">
                <div>{{ schedule.dFrom | dateFormat(_self) }} - {{ schedule.dTo | dateFormat(_self) }}</div>
              </el-col>
              <el-col :md="4" :lg="3" :xl="3">{{ $tc('deck.text-duration', schedule.duration, {nights: schedule.duration - 1, days: schedule.duration}) }}</el-col>
              <el-col :md="5" :lg="6" :xl="6" style="text-align: end;">{{ schedule.price | currencyFormat(schedule.currency) }}</el-col>
              <el-col :md="1" :lg="1" :xl="1">&nbsp;</el-col>
            </el-row>
          </el-col>
          <el-col :md="9" :lg="10" :xl="12">
            <el-row type="flex" justify="space-between">
              <el-col :md="12" :lg="12" :xl="12">
                <el-button type="text" @click="showVerlauf(schedule.dFrom, idObject)" class="deck_setverlauf">{{ $t('deck.tour-description') }}</el-button>
              </el-col>
              <el-col :md="12" :lg="12" :xl="12" style="text-align: right;">
                <el-button size="small" type="primary" @click.native="toggleTermin(schedule)">{{ $t('deck.select-schedule') }}</el-button>
              </el-col>
            </el-row>
          </el-col>
          <transition name="el-zoom-in-top" mode="out-in">
            <el-col v-if="schedule.idMediaObject === expandedSchedule" v-loading="!categoriesFetched" class="tbl-categories" :md="24" :lg="24" :xl="24">
              <el-row justify="center" type="flex">
                <el-col :md="23" :lg="23" :xl="23">
                  <el-row class="tbl-head">
                    <el-col :md="19" :lg="20" :xl="21">
                      <el-row>
                        <el-col :span="4" style="padding-left: 4px;">{{ $t('deck.category') }}</el-col>
                        <el-col :span="5">{{ $t('deck.deck') }}</el-col>
                        <el-col :span="9">{{ $t('deck.cabin-category') }}</el-col>
                        <el-col :span="2">{{ $t('deck.position') }}</el-col>
                        <el-col :span="4" style="text-align: end; text-overflow: ellipsis">{{ $t('deck.price-pp') }}</el-col>
                      </el-row>
                    </el-col>
                    <el-col :md="5" :lg="4" :xl="3">
                    </el-col>
                  </el-row>
                  <el-row v-for="(category, index) in categories" :key="'category_' + index" class="tbl-row">
                    <el-col :md="19" :lg="20" :xl="21">
                      <el-row>
                        <el-col :span="4" style="padding-left: 4px;">
                          <el-row type="flex" justify="space-between">
                            <el-col :span="12">{{ category.code }}</el-col>
                            <el-col :span="12">
                              <el-popover placement="right-start" width="400" trigger="hover" popper-class="category-popover" transition="el-fade-in-linear">
                                <el-row :gutter="10">
                                  <el-col :span="imgURL(category) === '' ? 24 :12">
                                    <!--<div style="word-break: normal">
                                      <b>{{ category.name }}</b>
                                    </div>-->
                                    <div v-html="category.cabins.data[0].description" style="word-break: normal; text-align: left"></div>
                                  </el-col>
                                  <el-col :span="imgURL(category) === '' ? 0 :12">
                                    <div v-if="imgURL(category) !== ''">
                                      <img :src="imgURL(category)" width="200" >
                                    </div>

                                  </el-col>
                                </el-row>
                                <el-row type="flex" justify="end">
                                  <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                                  <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category') }}</el-button>
                                  <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                                </el-row>
                                <i slot="reference" class="el-icon-info el-button--text category-icon"></i>
                              </el-popover>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="5">{{ category.deckNames.join(', ') }}</el-col>
                        <el-col :span="9" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ category.namePM }}</el-col>
                        <el-col :span="2">{{ category.location }}</el-col>
                        <el-col :span="4" style="text-align: end;">{{ category.price | currencyFormat(category.currency) }}</el-col>
                      </el-row>
                    </el-col>
                    <el-col :md="5" :lg="4" :xl="3">
                      <el-row>
                        <el-col :span="24" style="text-align: right;">
                          <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                          <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                          <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                        </el-col>
                      </el-row>
                    </el-col>
                    <transition name="el-zoom-in-top" mode="out-in">
                      <el-col v-if="expandedCategory === category.idMediaObject" :md="24" :lg="24" :xl="24">
                        <template v-for="deckName in category.filenamesDeck">
                          <div :key="deckName">
                            <deckplan :nodes="getDeckByName(deckName)" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                            <el-col :span="20" style="text-align: right;">
                              <el-button type="primary" :disabled="selectedCab === ''" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.select-cabin', { cabinNo: selectedCab }) }}</el-button>
                            </el-col>
                          </div>
                        </template>
                        <div style="min-height: 100px;"></div>
                      </el-col>
                    </transition>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </transition>
        </el-row>
      </div>
      <!-- tablet and mobile -->
      <div v-if="mediaquery < 4">
        <el-row v-for="(schedule, index) in schedules" :key="'schedule_' + index">
          <el-col :span="24">
            <el-row class="tbl-head tbl-row--mobile" type="flex" justify="space-between">
              <el-col :xs="18" :sm="11" class="tbl-head-td" :data-title="$t('deck.date')">{{ schedule.dFrom | dateFormat(_self) }} - {{ schedule.dTo | dateFormat(_self) }}</el-col>
              <el-col :xs="0" :sm="9" class="tbl-head-td" :data-title="$t('deck.duration')">{{ $t('deck.text-duration', {nights: schedule.duration - 1, days: schedule.duration}) }}</el-col>
              <el-col :xs="6" :sm="4" class="tbl-head-td" :data-title="$t('deck.price-pp')">{{ schedule.price | currencyFormat(schedule.currency) }}</el-col>
            </el-row>
            <el-row type="flex" justify="space-between" class="tbl-row--mobile">
              <el-col :xs="12" :sm="0" class="tbl-td" :data-title="$t('deck.duration')">{{ $t('deck.text-duration', {nights: schedule.duration - 1, days: schedule.duration}) }}</el-col>
              <el-col :xs="0" :sm="8" :offset="8">
                <el-button type="text" @click="showVerlauf(schedule.dFrom, idObject)">{{ $t('deck.tour-description') }}</el-button>
              </el-col>
              <el-col :xs="0" :sm="8" style="text-align: right;margin-top: 4px;">
                <el-button size="small" type="primary" @click.native="toggleTermin(schedule)">{{ $t('deck.select-schedule') }}</el-button>
              </el-col>
              <el-col :xs="12" :sm="0" style="text-align: right;padding-top: 6px;">
                <el-button type="primary" icon="el-icon-search" @click="showVerlauf(schedule.dFrom, idObject)" circle></el-button>
                <el-button type="primary" :icon="expandedSchedule === schedule.idMediaObject ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" circle @click.native="toggleTermin(schedule)"></el-button>
              </el-col>
            </el-row>
            <transition name="el-zoom-in-top" mode="out-in">
              <div v-if="schedule.idMediaObject === expandedSchedule" v-loading="!categoriesFetched">
                <template v-for="(category, index) in categories">
                  <el-divider :key="'divider_category_' + index"></el-divider>
                  <el-row  :key="'category_' + index" justify="center" type="flex">
                    <el-col :span="11">
                      <el-row class="tbl-row--mobile">
                        <div class="tbl-head-td" :data-title="$t('deck.category')">{{ category.code }}</div>
                      </el-row>
                      <el-row class="tbl-row--mobile">
                        <div class="tbl-head-td" :data-title="$t('deck.position')">{{ category.location }}</div>
                      </el-row>
                      <el-row class="tbl-row--mobile">
                        <div class="tbl-head-td">{{ category.price | currencyFormat(category.currency) }}</div>
                      </el-row>
                    </el-col>
                    <el-col :span="13">
                      <el-row class="tbl-row--mobile">
                        <div class="tbl-head-td" :data-title="$t('deck.cabin-category')">
                          <span>
                            <el-popover placement="bottom-start" width="300" trigger="click" popper-class="category-popover" transition="el-fade-in-linear">
                              <el-row :gutter="10">
                                <el-col :span="12">
                                  <div style="word-break: normal; text-align: left;">
                                    <b>{{ category.name }}</b>
                                  </div>
                                  <div v-html="category.description" style="word-break: normal; text-align: left;"></div>
                                </el-col>
                                <el-col :span="12">
                                  <div v-if="imgURL(category) !== ''">
                                    <img :src="imgURL(category)" width="150">
                                  </div>
                                  <el-row type="flex" justify="end">
                                    <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                                    <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                                    <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                                  </el-row>
                                </el-col>
                              </el-row>
                              <i slot="reference" class="el-icon-info el-button--text category-icon"></i>
                            </el-popover>
                          </span>
                          <span style="padding-left: 4px;">{{ category.namePM }}</span>
                        </div>
                      </el-row>
                      <el-row class="tbl-row--mobile">
                        <div class="tbl-head-td" :data-title="$t('deck.deck')">{{ category.deckNames.join(', ') }}</div>
                      </el-row>
                      <el-row class="tbl-row--mobile">
                        <div>
                          <el-button v-if="category.waitlist" type="primary" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                          <el-button v-else-if="category.isVirtual" type="primary" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                          <el-button v-else type="primary" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                        </div>
                      </el-row>
                    </el-col>
                  </el-row>
                  <transition name="el-zoom-in-top" mode="out-in" :key="'transition_' + index">
                      <el-row v-if="expandedCategory === category.idMediaObject">
                        <template v-for="deckName in category.filenamesDeck">
                          <div :key="deckName">
                            <el-col :xs="24" :sm="0">
                              <div class="container-space-area">
                                <div class="space-area">
                                  <deckplan :nodes="getDeckByName(deckName)" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="1500" width="1200" x="0px" y="0px" class="deck-svg--mobile" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                                </div>
                              </div>
                            </el-col>
                            <el-col :xs="0" :sm="10" :offset="2">
                              <div class="container-space-area">
                                <div id="deckplan" class="space-area-fix">
                                  <deckplan :nodes="getDeckByName(deckName)" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="1500" width="1200" x="0px" y="0px" class="deck-svg--tablet" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                                </div>
                              </div>
                            </el-col>
                            <el-col :xs="0" :sm="10" :offset="2">
                              <div class="container-space-area">
                                <div class="space-area-fix">
                                  <deckplan :nodes="getDeckByName(deckName)" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="500" width="450" x="0px" y="0px" class="deck-small-svg--tablet" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                                  <div id="draggie" v-draggabilly="{axis: 'y', containment: '.deck-small-svg--tablet'}" v-draggabilly-on:pointerDown="onPointerDown" v-draggabilly-on:dragMove="onDragMove" class="draggie">
                                    <img src="./assets/img/ship-navi.png">
                                  </div>
                                </div>
                              </div>
                            </el-col>
                            <el-col :xs="24" :sm="0" style="text-align: center; margin: 5px 0;">
                              <el-button type="primary" :disabled="selectedCab === ''" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.select-cabin', { cabinNo: selectedCab }) }}</el-button>
                            </el-col>
                            <el-col :xs="0" :sm="24" style="text-align: right; margin: 5px 0;">
                              <el-button type="primary" :disabled="selectedCab === ''" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.select-cabin', { cabinNo: selectedCab }) }}</el-button>
                            </el-col>
                          </div>
                        </template>
                      </el-row>
                    </transition>
                </template>
                <!-- <el-row  :key="'category_' + index" justify="center" type="flex">
                  <el-col :span="22">
                    <el-row class="tbl-head tbl-row--mobile">
                      <el-col :xs="18" :sm="14" class="tbl-head-td" :data-title="$t('deck.cabin-category')">{{ category.namePM }}</el-col>
                      <el-col :xs="0" :sm="4" class="tbl-head-td" :data-title="$t('deck.category')">{{ category.code }}</el-col>
                      <el-col :span="6" class="tbl-head-td" :data-title="$t('deck.price-pp')">{{ category.price | currencyFormat(category.currency) }}</el-col>
                    </el-row>
                    <el-row class="tbl-row--mobile">
                      <el-col :xs="9" :sm="0" class="tbl-td" :data-title="$t('deck.category')">
                        <el-row>
                          <el-col :span="7">{{ category.code }}</el-col>
                          <el-col :span="7">
                            <el-popover placement="bottom-start" width="300" trigger="click" popper-class="category-popover" transition="el-fade-in-linear">
                              <el-row :gutter="10">
                                <el-col :span="12">
                                  <div>
                                    <b>{{ category.name }}</b>
                                  </div>
                                  <div v-html="category.description"></div>
                                </el-col>
                                <el-col :span="12">
                                  <div v-if="imgURL(category) !== ''">
                                    <img :src="imgURL(category)" width="150">
                                  </div>
                                  <el-row type="flex" justify="end">
                                    <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                                    <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                                    <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                                  </el-row>
                                </el-col>
                              </el-row>
                              <i slot="reference" class="el-icon-info el-button--text category-icon"></i>
                            </el-popover>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :xs="9" :sm="0" class="tbl-td" :data-title="$t('deck.deck')">{{ category.deckName}}</el-col>
                      <el-col :xs="0" :sm="6" class="tbl-td" style="margin-top: 7px;">
                        <el-popover placement="bottom-start" width="400" trigger="click" popper-class="category-popover" transition="el-fade-in-linear">
                          <el-row :gutter="10">
                            <el-col :span="12">
                              <div>
                                <b>{{ category.name }}</b>
                              </div>
                              <div v-html="category.description"></div>
                            </el-col>
                            <el-col :span="12">
                              <div v-if="imgURL(category) !== ''">
                                <img :src="imgURL(category)" width="200">
                              </div>
                              <el-row type="flex" justify="end">
                                <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                                <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                                <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                              </el-row>
                            </el-col>
                          </el-row>
                          <i slot="reference" class="el-icon-info el-button--text category-icon"></i>
                        </el-popover>
                      </el-col>
                      <el-col :xs="0" :sm="12" class="tbl-td" style="margin-top: 7px;">{{ category.deckName }}</el-col>
                      <el-col :xs="6" :sm="0" class="tbl-td" style="text-align: right;margin-top: 6px;">
                        <el-button v-if="category.waitlist" icon="el-icon-tickets" type="primary" circle @click.native="goToIBE(category.idMediaObject)"></el-button>
                        <el-button v-else-if="category.isVirtual" icon="el-icon-check" type="primary" circle @click.native="goToIBE(category.idMediaObject)"></el-button>
                        <el-button v-else type="primary" :icon="category.idMediaObject === expandedCategory ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" circle  @click.native="toggleCategory(category)"></el-button>
                      </el-col>
                      <el-col :xs="0" :sm="6" class="tbl-td" style="text-align: right;padding: 5px 0;">
                        <el-button v-if="category.waitlist" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.waitlist') }}</el-button>
                        <el-button v-else-if="category.isVirtual" type="primary" size="mini" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.book-category')}}</el-button>
                        <el-button v-else type="primary" size="mini" @click.native="toggleCategory(category)">{{ $t('deck.select-category') }}</el-button>
                      </el-col>
                    </el-row>
                    <transition name="el-zoom-in-top" mode="out-in">
                      <el-row v-if="expandedCategory === category.idMediaObject">
                        <el-col :xs="24" :sm="0">
                          <div class="container-space-area">
                            <div class="space-area">
                              <deckplan :nodes="decks[activeDeck].deck" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="1500" width="1200" x="0px" y="0px" class="deck-svg--mobile" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="0" :sm="10" :offset="2">
                          <div class="container-space-area">
                            <div id="deckplan" class="space-area-fix">
                              <deckplan :nodes="decks[activeDeck].deck" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="1500" width="1200" x="0px" y="0px" class="deck-svg--tablet" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="0" :sm="10" :offset="2">
                          <div class="container-space-area">
                            <div class="space-area-fix">
                              <deckplan :nodes="decks[activeDeck].deck" :catCabins="getCatCabins(category.cabins.vacancy)" :allCabins="getAllCabins()" height="500" width="450" x="0px" y="0px" class="deck-small-svg--tablet" @click.native="handleClick" @mouseenter="handleMouseEnter($event, category)" @mouseleave="handleMouseLeave"></deckplan>
                              <div id="draggie" v-draggabilly="{axis: 'y', containment: '.deck-small-svg--tablet'}" v-draggabilly-on:pointerDown="onPointerDown" v-draggabilly-on:dragMove="onDragMove" class="draggie">
                                <img src="./assets/img/ship-navi.png">
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="24" :sm="0" style="text-align: center; margin: 5px 0;">
                          <el-button type="primary" :disabled="selectedCab === ''" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.select-cabin', { cabinNo: selectedCab }) }}</el-button>
                        </el-col>
                        <el-col :xs="0" :sm="24" style="text-align: right; margin: 5px 0;">
                          <el-button type="primary" :disabled="selectedCab === ''" @click.native="goToIBE(category.idMediaObject)">{{ $t('deck.select-cabin', { cabinNo: selectedCab }) }}</el-button>
                        </el-col>
                      </el-row>
                    </transition>
                  </el-col>
                </el-row> -->
              </div>
            </transition>
          </el-col>
        </el-row>
      </div>
    </div>
    <div id="tooltip" class="tooltipContainer" style="display: none;"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import Deckplan from './components/Deckplan'
import { mapState, mapMutations } from 'vuex'
import http from '@/api/http'

// require('classlist-polyfill')

export default {
  name: 'Overview',
  data () {
    return {
      schedules: [],
      expandedSchedule: '0',
      expandedCategory: 0,
      categoriesFetched: true,
      decks: [],
      idObject: 0,
      categories: [],
      selectedCab: '',
      selectedCabTemp: '',
      media: {
        1: '(max-width: 479px)',
        2: '(min-width: 480px) and (max-width: 767px)',
        3: '(min-width: 768px) and (max-width: 991px)',
        4: '(min-width: 992px) and (max-width: 1919px)',
        5: '(min-width: 1920px)'
      },
      yPos: 0
    }
  },
  created () {
    this.idObject = window.initData.idMediaObject
    this.selectedCab = window.initData.cabinNumber
    this.expandedSchedule = window.initData.idSchedule
    this.expandedCategory = window.initData.idCategory
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)

    http.getSchedules({
      idMediaObject: this.idObject,
      language: window.initData.language,
      currency: window.initData.currency,
      idShip: window.initData.idShip,
      includeVirtualCategories: window.initData.guaranteeCategoryAvailable,
    })
      .then(
        response => {
          return response
        },
        error => {
          console.log(error)
        }
      )
      .then(data => {

        this._each(data, schedule => {
          let price = 1000000000
          this._each(schedule.categories, category => {
            if (category.price < price) {
              price = category.price
            }
          })
          schedule.price = price
        })
        // filter out schedules matching date offset
        const dOffset = this.addDays(window.initData.dateOffset);
        data = this._filter(data, schedule => {
          // console.log(dOffset, new Date(schedule.dFrom), new Date(schedule.dFrom) >= dOffset)
          return new Date(schedule.dFrom) >= dOffset
        })

        this.schedules = data
      })
      .then(() => {
        if (this.schedules.length === 1) {
          this.toggleTermin(this.schedules[0])
        }
      })
  },
  mounted () {
    this.setMediaquery(this.getMediaquery())
  },
  updated () {
    if (this.selectedCab !== this.selectedCabTemp) {
      let rElems = document.querySelectorAll('#r_' + this.selectedCab)
      let nElems = document.querySelectorAll('#n_' + this.selectedCab)
      this._each(rElems, (elem, i) => {
        rElems[i].classList.add('cab-select')
        nElems[i].classList.add('cabno-select')
      })
      this.selectedCabTemp = this.selectedCab
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['mediaquery'])
  },
  methods: {
    ...mapMutations({
      setMediaquery: 'SET_MEDIAQUERY'
    }),
    addDays(days) {
      const dNow = new Date()
      var result = new Date(dNow.getFullYear(), dNow.getMonth(), dNow.getDate(), 0, 0, 0, 0);
      result.setDate(result.getDate() + days);
      return result;
    },
    showVerlauf (date, id) {
      if (window.setDateReiseverlauf) {
        window.setDateReiseverlauf(date, id)
      }
    },
    imgURL (category) {
      return category.cabins.data[0].imageUrls && category.cabins.data[0].imageUrls[0] !== '' ? category.cabins.data[0].imageUrls[0] : ''
    },
    goToIBE1 (idCategory) {
      let url = `${window.initData.httpRoot}/?pm=buchung&idObject=${
        this.idObject
      }`
      url += `&idTermin=${this.expandedSchedule}&idCategory=${
        idCategory
      }&cabinNumber=${this.selectedCab}`

      window.location.href = url
    },
    goToIBE (idCategory) {
      const lang = window.initData.language.toLowerCase() === 'en' ? '/en' : ''
      let queryString = `?id_media_object=${window.initData.idMediaObject}&id_media_object_termin=${this.expandedSchedule}&id_media_object_category=${idCategory}&cabin_number=${this.selectedCab}&agency_no=${window.initData.agenturNr}`

      window.location.href = `${lang}/buchung/${queryString}`
    },
    toggleTermin (schedule) {
      if (this.expandedSchedule === schedule.idMediaObject) {
        this.expandedSchedule = '0'
      } else {
        this.expandedSchedule = schedule.idMediaObject
        this.getCategories(schedule)
      }
    },
    toggleCategory (category) {
      this.yPos = 0
      if (this.expandedCategory === category.idMediaObject) {
        this.expandedCategory = 0
      } else {
        this.getDeckplan(category)
      }
    },
    getSchedules () {
      http
        .getSchedules({
          packageCodes: window.initData.packageCodes,
          language: window.initData.language,
          currency: window.initData.currency,
          idShip: window.initData.idShip,
          includeVirtualCategories: window.initData.guaranteeCategoryAvailable,
        })
        .then(
          response => {
            return response
          },
          error => {
            console.log(error)
          }
        )
        .then(data => {
          this.schedules = data
        })
    },
    getCategories (schedule) {
      this.categories = schedule.categories.sort( ( a, b ) => a.position > b.position && 1 || -1 );
    },
    getDeckplanIndex(deckName) {
      return this._findIndex(this.decks, {fileName: deckName})
    },
    getDeckByName(deckName) {
      const deckIndex = this.getDeckplanIndex(deckName)

      return this.decks[deckIndex].deck
    },
    async getDeckplan (category) {
      let deckNames = category.filenamesDeck

      await Promise.all(deckNames.map(async (deckName) => {
        if (this.getDeckplanIndex(deckName) === -1) {
          await http.getDeckplan({fileName: deckName})
            .then(response => {
              return response
            }, error => {
              console.log(error)
            })
            .then(data => {
              this.decks.push(data)
            })
        }
      })).then(() => {
        this.expandedCategory = category.idMediaObject
      })
    },
    getLocalDateString (value) {
      let date = new Date(value)
      let options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }
      return date.toLocaleDateString(Vue.config.lang, options)
    },
    getCatCabins (vacancies) {
      return this._filter(vacancies, vacancy => {
        return vacancy.seatMap.state === 'Bookable'
      })
    },
    getAllCabins () {
      return this._filter(this._flatMap(this._filter(this.categories, category => {
        return !category.isVirtual;
      }), value => {
        return value.cabins.vacancy
      }), vacancy => {
        return vacancy.seatMap.state === 'Bookable'
      })
    },
    getCategoryByCabin (cab) {
      return this._find(this.categories, category => {
        return this._findIndex(category.cabins.vacancy, { unit: cab }) !== -1 && !category.isVirtual
      })
    },
    toggleHoverClasses (evt, method) {
      let cab = evt.target.attributes.getNamedItem('cab').value
      let rElems = document.querySelectorAll('#r_' + cab)
      let nElems = document.querySelectorAll('#n_' + cab)

      this._each(rElems, (elem, i) => {
        if (rElems[i].classList) {
          rElems[i].classList[method]('cab-hover')
          nElems[i].classList[method]('cabno-hover')
        }
      })
    },
    handleClick (evt) {
      let cab = evt.target.attributes.getNamedItem('cab').value

      // if (this.expandedCategory === this.getCategoryByCabin(cab).id) {
      if (evt.target.classList.contains('cab-on') || evt.target.classList.contains('cabno-on')) {
        this.changeCabClasses(cab)
      } else {
        this.toggleCategory(this.getCategoryByCabin(cab))
        setTimeout(() => {
          this.changeCabClasses(cab)
        }, 500)
      }
    },
    changeCabClasses (cab) {

      let rElems = document.querySelectorAll(`[cab="${cab}"]`)
      let nElems = document.querySelectorAll(`[cab="${cab}"]`)
      let rElemsTemp = document.querySelectorAll(`[cab="${this.selectedCabTemp}"]`)
      let nElemsTemp = document.querySelectorAll(`[cab="${this.selectedCabTemp}"]`)

      if (rElems[0].classList.contains('cab-select')) {
        this._each(rElems, (elem, i) => {
          rElems[i].classList.remove('cab-select')
          nElems[i].classList.remove('cabno-select')
        })
        this.selectedCab = ''
        this.selectedCabTemp = ''
      } else if (!rElems[0].classList.contains('cab-off')) {
        this.selectedCab = cab
        this._each(rElems, (elem, i) => {
          rElems[i].classList.remove('cab-select')
          nElems[i].classList.remove('cabno-select')
        })
        if (nElemsTemp) {
          this._each(rElemsTemp, (elem, i) => {
            rElemsTemp[i].classList.remove('cab-select')
            nElemsTemp[i].classList.remove('cabno-select')
          })
        }
      }
    },
    handleMouseEnter (evt, category) {
      let el = document.getElementById('tooltip')
      let cab = evt.target.attributes.getNamedItem('cab').value
      let parsedCab = attributes.cab.substring(0, 1) === '0' ? cab : parseInt(cab);
      // available cabin in this category
      if (this._find(category.cabins.vacancy, { unit: parsedCab })) {
        this.toggleHoverClasses(evt, 'add')
        el.innerHTML = this.$t('deck.bookable')

        // available cabin in other category
      } else if (this._find(this.getAllCabins(), { unit: parsedCab })) {
        let catCode = this.getCategoryByCabin(parsedCab).code
        this.toggleHoverClasses(evt, 'add')
        el.innerHTML = this.$t('deck.bookable-other-category', {
          categoryCode: catCode
        })

        // unavailable cabin
      } else {
        el.innerHTML = this.$t('deck.not-bookable')
      }

      el.style.left = evt.clientX + 15 + 'px'
      el.style.top = evt.clientY + 10 + 'px'
      el.style.display = 'block'
    },
    handleMouseLeave (evt) {
      let el = document.getElementById('tooltip')

      this.toggleHoverClasses(evt, 'remove')
      el.innerHTML = ''
      el.style.display = 'none'
    },
    handleResize () {
      this.setMediaquery(this.getMediaquery())
    },
    getMediaquery () {
      let mediaKey = 4
      this._each(this.media, (val, key) => {
        if (window.matchMedia(val).matches) {
          mediaKey = parseInt(key)
        }
      })
      return mediaKey
    },
    onPointerDown (evt, pointer) {
      let rect = document.getElementById('draggie').getBoundingClientRect()
      if (this.yPos === 0) {
        this.yPos = rect.top * 2.2
      }
    },
    onDragMove (evt, pointer, moveVector) {
      let el2 = document.querySelector('#draggie')
      let el = document.querySelector('#deckplan')
      el.scrollTop = el2.getBoundingClientRect().top * 2.1 - this.yPos
    },
    handleScroll (event) {
      this.yPos = 0
    }
  },
  components: {
    deckplan: Deckplan
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Rubik", sans-serif;
  background: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.tbl-schedules {
  text-align: left;
}
.tbl-schedules .tbl-head {
  background: #f2a603;
  color: #1c1c3c;
  font-size: 16px;
  font-weight: bolder;
  line-height: 2.8;
}
.tbl-schedules .tbl-row {
  line-height: 3.2;
  font-size: 14px;
}
.tbl-schedules .tbl-row--mobile {
  line-height: 2;
  padding: 0 5px;
  font-size: 14px;
}
.tbl-schedules .tbl-td:before {
  float: left;
  width: 100%;
  font-family: "NovaRegular", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: rgba(176, 190, 197, 1);
  display: table-cell;
  white-space: nowrap;
  text-align: left;
  content: attr(data-title);
}
.tbl-schedules .tbl-head-td:before {
  float: left;
  width: 100%;
  font-family: "NovaRegular", Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: table-cell;
  white-space: nowrap;
  text-align: left;
  content: attr(data-title);
}
.tbl-row:not(:last-child) {
  border-bottom: 1px solid #ccc;
}
.tbl-categories {
  min-height: 200px;
}
.category-icon {
  font-size: 16px;
  margin-top: 15px;
}
.category-popover {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.cab-select {
  fill: rgb(28, 28, 97) !important;
}
.cabno-select {
  fill: #fff !important;
}
.cab-hover {
  fill: rgb(28, 28, 97) !important;
}
.cabno-hover {
  fill: #fff !important;
}
.tooltipContainer {
  position: fixed;
  height: auto;
  width: auto;
  box-shadow: 0 0 6px #000;
  border-radius: 4px;
  background: white;
  padding: 5px;
  z-index: 999;
}
.deck-svg--mobile {
  -ms-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  margin-top: -180px;
  margin-left: -450px;
}
.deck-svg--tablet {
  -ms-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  margin-top: -180px;
  margin-left: -490px;
}
.deck-small-svg--tablet {
  -ms-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  margin-left: -120px;
}
.container-space-area {
  position: relative;
}
.space-area {
  height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.space-area-fix {
  height: 500px;
  overflow-y: hidden;
  overflow-x: hidden;
}
.space-area::-webkit-scrollbar {
  display: none;
}
.draggie {
  margin-top: -500px;
  margin-left: 30px;
}
</style>
